// @flow
import { toggleFilterDrawer } from '../../../duck/actions';

export { toggleFilterDrawer } from '../../../duck/actions';

export default {
    toggleFilterDrawer,
};
